
































import { Component, Prop, Vue } from 'vue-property-decorator';
import AddChildrenButton from '@/components/ext/Button.vue';
import ButtonCanRequest from '@/presets/button/can-request';
import { Checkbox } from '@/components/form/';

@Component({
  components: {
    AddChildrenButton,
    ButtonCanRequest,
    Checkbox,
  },
})
export default class ComponetsOrdersComponetsOrderAddChildren extends Vue {
  @Prop({ type: Array, default: () => [] })
  items: Array<any>;

  showBtn: boolean = true;
  checked: any = {};

  get isChecked(): boolean {
    return this.selected.length > 0;
  }

  get selected(): Array<string> {
    const { checked } = this;
    return Object.keys(checked).reduce((sum: Array<string>, key: string) => {
      if (checked[key]) {
        sum.push(key);
      }
      return sum;
    }, []);
  }

  addChildren() {
    if (this.isChecked) {
      this.$emit('addCheckedChildren', this.selected);
      this.cancel();
    }
  }

  cancel() {
    this.checked = {};
    this.showBtn = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderAddChildren.vue